/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit One/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function One({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates/LocationChooser/Content/One"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectedLocations0TextValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'locations[0].text',
})
let constantData = '-'
let aggregateData = fromAggregate.any(selectedLocations0TextValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="One.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-ll8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="One.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
location
</span>
<Info
  viewPath={`${viewPath}/Info`}
 marginLeft={8}
 marginTop={6}
 data="selected.locations[0].text"
 data="'-'"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}